import React, { lazy } from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    name: 'Elena M.',
    location: 'CIUDAD DE MÉXICO, MX',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=70&w=160&h=160&auto=format&fit=crop',
    quote: 'Por primera vez en años, despierto con energía. La niebla mental desapareció por completo y por fin vuelvo a sentirme yo misma.'
  }, {
    name: 'Sara T.',
    location: 'BOGOTÁ, CO',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=70&w=160&h=160&auto=format&fit=crop',
    quote: "Pensé que mis síntomas eran 'normales' para mi edad. Este método me demostró que no, y me dio los pasos exactos para solucionarlos."
  }, {
    name: 'Lucía R.',
    location: 'BUENOS AIRES, AR',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=70&w=160&h=160&auto=format&fit=crop',
    quote: 'Sin dietas extremas, sin suplementos raros. Solo hábitos diarios simples que realmente funcionan. Mi hinchazón desapareció en dos semanas.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-189">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-190">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-12" data-id="element-191">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-192">
              <div className="flex flex-col items-center text-center group" data-id="element-193">
                <div className="w-20 h-20 rounded-full overflow-hidden mb-6 shadow-soft group-hover:scale-105 transition-transform duration-500" data-id="element-194">
                  <img src={t.image} alt={t.name} width={80} height={80} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-195" />
                </div>

                <div className="flex gap-1 mb-6" data-id="element-196">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-sand text-sand" data-id="element-197" />)}
                </div>

                <div className="relative mb-8" data-id="element-198">
                  <span className="absolute -top-6 -left-4 font-serif text-6xl text-sand/20 leading-none" data-id="element-199">
                    "
                  </span>
                  <p className="font-serif text-lg md:text-2xl text-ink italic leading-relaxed relative z-10" data-id="element-200">
                    {t.quote}
                  </p>
                </div>

                <div className="mt-auto" data-id="element-201">
                  <p className="text-sm font-medium text-ink mb-1" data-id="element-202">{t.name}</p>
                  <p className="text-xs uppercase tracking-widest text-ink-light" data-id="element-203">
                    {t.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}